var borders_default = {
  "borderT": "Rfmdq",
  "borderB": "fr8Vf",
  "borderL": "ZiHxi",
  "borderR": "E7EoW"
};
export {
  borders_default as default
};
//# sourceMappingURL=borders-scss.js.map
